import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, WhyUs, NewsletterSection, Features, Clients, Mission, Team, FAQs, ProjectSection, Process, Industries, Pricing } from '../../sections';
import { Banner } from '../../components';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Hero section with a call-to-action */}
      <Features /> {/* Features Section */}
      <About /> {/* About the company */}
      <WhyUs /> {/* Why Choose Us section */}
      <Services /> {/* Services offered */}
      <Counter /> {/* Company stats and achievements */}
      <Process /> {/* Process slider section */}
      <Mission /> {/* Mission section */}
      <ProjectSection /> {/* Project Section */}
      <Industries /> {/* Served Industries Section */}
      <FAQs /> {/* FAQs Section */}
      <Banner /> {/* Promotional banner */}
      <Pricing /> {/* Pricing Section */}
      <Testimonials /> {/* Client reviews */}
      <Team /> {/* Team section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Clients /> {/* Clients Section */}
    </div>
  )

}

export default HomePage;